function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Mobile-default",
  stroke: "none",
  strokeWidth: 1,
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "iPhone-11",
  transform: "translate(-318.000000, -473.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-10",
  transform: "translate(318.000000, 473.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  cx: 12,
  cy: 12,
  r: 12
}), /*#__PURE__*/React.createElement("path", {
  d: "M11,15.3666 C11,16.359 10.2148333,17.1666 9.25,17.1666 C8.28516667,17.1666 7.5,16.359 7.493,15.3666 L7.493,14.2176 L11,15.3138 L11,15.3666 Z M17.7083333,6 C17.5473333,6 17.4166667,6.1344 17.4166667,6.3 L17.4166667,6.678 L4.58333333,10.695 L4.58333333,10.5 C4.58333333,10.3344 4.45208333,10.2 4.29166667,10.2 C4.13066667,10.2 4,10.3344 4,10.5 L4,13.5 C4,13.6656 4.13066667,13.8 4.29166667,13.8 C4.45208333,13.8 4.58333333,13.6656 4.58333333,13.5 L4.58333333,13.3044 L6.91666667,14.0352 L6.91666667,15.3666 C6.91666667,16.6902 7.96316667,17.7666 9.25,17.7666 C10.49425,17.7666 11.5115833,16.758 11.5763333,15.4938 L17.4166667,17.322 L17.4166667,17.7 C17.4166667,17.8656 17.5473333,18 17.7083333,18 C17.86875,18 18,17.8656 18,17.7 L18,6.3 C18,6.1344 17.86875,6 17.7083333,6 L17.7083333,6 Z",
  id: "Fill-1",
  fill: "#FFFFFF"
})))));

function SvgNews(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNews);
export default __webpack_public_path__ + "static/media/news.11367421.svg";
export { ForwardRef as ReactComponent };